"use client";

import { useTealiumPageView } from "@repo/ui/Hooks/useTealiumPageView";

import { tealiumView } from "@/lib/tealium/tealium";

/**
 * Emits a `utag.view` for every page load in the main app, hard reload and client-side
 * navigation alike.
 *
 * `culture` is resolved on the server and passed in rather than read from the Redux
 * locale slice: `locale` is not in the redux-persist whitelist, so on a hard reload the
 * slice sits on its hardcoded `es-CL` fallback until `LocaleHydrator` has fetched the
 * session preferences — long after the first view would have fired.
 *
 * Note this app defers utag.js until the first user interaction (or a ~3.5s idle
 * callback), so the landing view fires later here than in the booking apps. The hook
 * awaits the readiness promise, so it is queued rather than dropped.
 */
export default function TealiumPageView({ culture }: Readonly<{ culture: string }>) {
  useTealiumPageView({ culture, view: tealiumView });

  return null;
}
